var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "mb-5 lg:mb-15 2xl:mb-20"
  }, [_vm._v("\n    Les offres Neopass\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-x-13 justify-items-center mx-15"
  }, [_c('subscription-card', {
    attrs: {
      "name": "GRATUIT",
      "description": "(Sans engagement)",
      "details": ['Filigrane sur PDF', 'Évaluation des compétences (Jusqu’à 2 historiques)', 'Recherche par Compétences', 'Plan d’Accompagnement Personnalisé', 'Préconisation Emploi/stage', 'Suivi des stages et mises à disposition', 'Frise chronologique', 'Bibliothèque de fiches de postes (Jusqu’à 10 FDP)', 'Cartographies individuelles / collectives (Jusqu’à 2 historiques)', 'Support client mail uniquement'],
      "is-current": true,
      "price": 0
    }
  }), _vm._v(" "), _c('subscription-card', {
    attrs: {
      "name": "PILOTE",
      "description": "(12 mois sans engagement)",
      "details": ['PDF sans filigrane', 'Évaluations des compétences (Illimitées)', 'Recherche par Compétences', 'Plan d’Accompagnement Personnalisé', 'Préconisation Emploi/stage', 'Suivi des stages et mises à disposition', 'Frise chronologique', 'Dépôt de documents', 'Bibliothèque de fiches de postes (Illimitées)', 'Cartographies individuelles / collectives (Illimitées)', 'Formation 2 jours en présentiel', 'Support client mail + tél', 'Suivi commercial'],
      "is-current": false,
      "price": 3800
    }
  }), _vm._v(" "), _c('subscription-card', {
    attrs: {
      "name": "EXPERT",
      "description": "(Engagement sur 24 mois)",
      "details": ['Mode GRATUIT + PILOTE', 'Fonctionnalités illimitées', 'Personnalisation des formulaires d’évaluations', 'Formation 2 jours en présentiel', 'Formation visio personnalisée (Jusqu’à 6h/an)', 'Support client mail + tél', 'Suivi commercial'],
      "is-current": false,
      "price": 8800
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }